<template>
	<div class="docs-form">
		<div class="docs-form__files">
			<div class="docs-form__files-title">
				<h1 class="docs-form__files-title--text">Documentos da Oferta</h1>
			</div>
			<draggable
				class="drag-list"
				v-bind="dragOptions"
				:list="offer.offerDocs"
				@change="changeOfferOrder"
				v-if="offer.offerDocs.length"
			>
				<div class="docs-form__files-form" v-for="(doc, index) in offer.offerDocs" :key="index">
					<div class="docs-form__direction">
						<div class="docs-form__files-form--move">
							<MoveIcon />
						</div>
						<div class="docs-form__direction-margins docs-form__direction-margins--variant">
							<InputGroup
								:title="'Nome do Documento'"
								:customClass="'full'"
								:id="`docs_name_${index + 1}`"
								:placeholder="'Nome do Documento'"
								v-model="doc.name"
							/>
						</div>
						<div class="docs-form__direction-margins docs-form__direction-margins--variant">
							<InputGroup
								:title="'Upload de Arquivo'"
								:customClass="'full'"
								:id="`docs_file_${index + 1}`"
								:ref="`docs_file_${index + 1}`"
								:placeholder="'Upload de Arquivo'"
								:isFile="true"
								v-model="doc.docUrl"
							/>
						</div>
					</div>
					<div class="docs-form__direction">
						<div class="docs-form__direction-margins">
							<MultiselectGroup
								:isWeb="isWeb"
								:label="'Tipo de Documento:'"
								:type="`doc_type_${index + 1}`"
								:options="docTypeOptions"
								:placeholder="'Tipo de Documento'"
								:alert="false"
								:ref="`doc_type_${index + 1}`"
								@changeMultiselectInput="changeTypeInput"
							/>
						</div>
						<div class="w-100 margin-docs">
							<MultiselectGroup
								:isWeb="isWeb"
								:label="'Subtipo de Documento:'"
								:type="`doc_subtype_${index + 1}`"
								:options="docSubtypeOptions"
								:placeholder="'Subtipo de Documento'"
								:alert="false"
								:ref="`doc_subtype_${index + 1}`"
								@changeMultiselectInput="changeSubtypeInput"
							/>
						</div>
					</div>
					<div class="docs-form__files-form--delete" @click="removeDocs(doc)">
						<span>Excluir Documento</span>
					</div>
				</div>
			</draggable>
			<span class="docs-form__files-title--icon docs-form__files-title--subText" @click="addNewDocs()">
				Incluir Documentos <PlusIconVariant />
			</span>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import draggable from 'vuedraggable';

import InputGroup from '@/components/modules/Offer/OfferDetail/InputGroup/InputGroup.vue';
import MultiselectGroup from '@/components/modules/Offer/OfferDetail/MultiselectGroup/MultiselectGroup.vue';
import PlusIconVariant from '@/components/shared/Icons/PlusIconVariant.vue';
import ArrowIcon from '@/components/shared/Icons/ArrowIcon.vue';
import MoveIcon from '@/components/shared/Icons/MoveIcon.vue';

export default {
	name: 'OfferDocsForm',
	components: {
		draggable,
		InputGroup,
		MultiselectGroup,
		PlusIconVariant,
		ArrowIcon,
		MoveIcon,
	},
	props: {
		isWeb: {
			required: true,
		},
		isEditing: {
			required: true,
		},
	},
	data: () => ({
		offer: {
			offerDocs: [
				{
					id: null,
					name: null,
					docUrl: null,
					docTypeId: null,
					docSubtypeId: null,
					index: 1,
				},
			],
		},
	}),
	methods: {
		addNewDocs() {
			this.offer.offerDocs.push({
				id: null,
				name: null,
				docUrl: null,
				docTypeId: null,
				docSubtypeId: null,
				index: this.offer.offerDocs.length + 1,
			});
		},
		removeDocs(param) {
			//param.index é o index da LISTA e não do objeto doc
			this.offer.offerDocs.splice(param.index - 1, 1);

			this.offer.offerDocs.forEach((doc, index) => {
				doc.index = index + 1;

				const splitedDocName = doc.docUrl?.split('/');

				if (!doc.docType) {
					const docTypeOption = this.docTypeOptions.find((item) => item.id == doc.docTypeId);
					const docSubtypeOption = this.docSubtypeOptions.find(
						(item) => item.id == doc.docSubtypeId,
					);

					this.$refs[`doc_type_${index + 1}`][0].setValue(docTypeOption);
					this.$refs[`doc_subtype_${index + 1}`][0].setValue(docSubtypeOption);
				} else {
					this.$refs[`doc_type_${index + 1}`][0].setValue(doc.docType);
					this.$refs[`doc_subtype_${index + 1}`][0].setValue(doc.docSubtype);
				}

				this.$refs[`docs_file_${index + 1}`][0].setFileName(
					splitedDocName ? splitedDocName[splitedDocName.length - 1] : null,
				);
			});
		},
		changeOfferOrder() {
			if (this.offer.offerDocs?.length) {
				this.offer.offerDocs.forEach((doc, index) => {
					doc.index = index + 1;

					setTimeout(() => {
						const splitedDocName = doc.docUrl.split('/');

						this.$refs[`doc_type_${index + 1}`][0].setValue(doc.docType);
						this.$refs[`doc_subtype_${index + 1}`][0].setValue(doc.docSubtype);
						this.$refs[`docs_file_${index + 1}`][0].setFileName(
							splitedDocName[splitedDocName.length - 1],
						);
					}, 50);
				});
			}
		},
		changeTypeInput(param) {
			const typeIndex = param.type.split('_')[2];

			if (this.isEditing) {
				this.offer.offerDocs[typeIndex - 1].docType = param.value;
			}

			this.offer.offerDocs[typeIndex - 1].docTypeId = param.value.id;
		},
		changeSubtypeInput(param) {
			const subtypeIndex = param.type.split('_')[2];

			if (this.isEditing) {
				this.offer.offerDocs[subtypeIndex - 1].docSubtype = param.value;
			}

			this.offer.offerDocs[subtypeIndex - 1].docSubtypeId = param.value.id;
		},
		loadOfferDetails(selectedOffer) {
			this.offer.offerDocs = selectedOffer.offerDocs.map((doc, index) => {
				const updatedDoc = { ...doc, index: index + 1 };

				this.updateRefsWithDocValues(updatedDoc, index);

				return updatedDoc;
			});
		},
		updateRefsWithDocValues(doc, index) {
			setTimeout(() => {
				const splitedDocName = doc.docUrl.split('/');

				this.$refs[`doc_type_${index + 1}`][0].setValue(doc.docType);
				this.$refs[`doc_subtype_${index + 1}`][0].setValue(doc.docSubtype);
				this.$refs[`docs_file_${index + 1}`][0].setFileName(
					splitedDocName[splitedDocName.length - 1],
				);
			}, 500);
		},
		getDocsData() {
			return this.offer;
		},
		getDocFile(docRef) {
			return this.$refs[docRef][0].getFile();
		},
	},
	computed: {
		...mapGetters('offerManagement', ['offerDocTypes', 'offerDocSubtypes']),
		dragOptions() {
			return {
				animation: 200,
				group: 'description',
				disabled: false,
				ghostClass: 'ghost',
			};
		},
		docTypeOptions() {
			return this.offerDocTypes.docTypes?.length ? this.offerDocTypes.docTypes : [];
		},
		docSubtypeOptions() {
			return this.offerDocSubtypes.docSubtypes?.length ? this.offerDocSubtypes.docSubtypes : [];
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'OfferDocsForm.scss';
</style>
